export default __webpack_public_path__ + "static/media/logout.e85fd5da.svg";